
import React, { Fragment } from 'react'
import DataHeader from 'components/datatable/DataHeader'
import DetailDataTableRow from './DetailDataTableRow'

const DetailDataTable = (props) => {
    const { data, columns, coltype, ...rest } = props
    const rowno = 1
    return (
        <Fragment>
            <div className="col-12">
                <table className="table sortable table-bordered table-hover table-striped table-condensed" >
                    <thead>
                        <DataHeader columns={columns} coltype={coltype} />
                    </thead>
                    <tbody>
                        {data && data.map((item, i) =>
                            <DetailDataTableRow
                                rowno={rowno + i}
                                key={"rowdata-" + i}
                                columns={columns}
                                item={item}
                                coltype={coltype}
                                {...rest}
                            />
                        )}
                    </tbody>
                </table >
            </div>
        </Fragment >
    )
}

DetailDataTable.defaultProps = {
    data: null,
    columns: null,
    coltype: null,
    paging: { "page": 1, "perpage": 10 },
    changeSort: () => { }
}

export default DetailDataTable